module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Registered with success!","description-1":"Your password will be sent to your email","description-2":", remember to check your trash or spam box."},"pt-BR":{"title":"Cadastro realizado com sucesso!","description-1":"A sua senha chegará no email","description-2":", verifique também na lixeira ou na caixa de spam."}}')
  delete Component.options._Ctor
}
